"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Dropdown_1 = __importDefault(require("../../Dropdown"));
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var dropdown_svg_1 = __importDefault(require("../../../../images/icons/dropdown.svg"));
var useActionForbidden_1 = require("../../../hooks/useActionForbidden");
var react_router_dom_1 = require("react-router-dom");
var Routes_1 = require("../../../constants/Routes");
var react_redux_1 = require("react-redux");
var loginSlice_1 = require("../../../features/login/loginSlice");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TopHeader = react_1.memo(function (_a) {
    var languageChangeHandler = _a.languageChangeHandler, languageList = _a.languageList, currentLanguage = _a.currentLanguage, isAnnouncementPage = _a.isAnnouncementPage, currencyChangeHandler = _a.currencyChangeHandler, currencyList = _a.currencyList, currentCurrency = _a.currentCurrency, _b = _a.hidePostButton, hidePostButton = _b === void 0 ? false : _b;
    var t = react_i18next_1.useTranslation('common').t;
    var isLoginOpen = react_redux_1.useSelector(loginSlice_1.selectLoginModalIsOpen);
    var history = react_router_dom_1.useHistory();
    var openAnnouncement = useActionForbidden_1.useActionForbidden(function () {
        history.push(Routes_1.Routes.Announcement.path);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, !isAnnouncementPage && !isLoginOpen && (react_1.default.createElement("div", { className: "top" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "contact-phone" },
                react_1.default.createElement("a", { href: "tel:" + GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.PHONE_NUMBER },
                    react_1.default.createElement("i", { className: "cm-icon icon-phone" }),
                    t('call_now'),
                    " \u00A0",
                    GeneralSettings_1.GENERAL_SETTINGS.CONTACT_PHONE.FORMATED)),
            react_1.default.createElement("div", { className: "curr-lang" },
                react_1.default.createElement(Dropdown_1.default, { classList: "currency-picker", onChange: currencyChangeHandler, itemKey: "code", itemValue: "original", list: currencyList, selected: currentCurrency, itemTemplate: function (elem) {
                        return (react_1.default.createElement(react_1.Fragment, null,
                            react_1.default.createElement("span", null, elem.curSymbol + " " + elem.original),
                            react_1.default.createElement("img", { className: styles_module_scss_1.default.dropdown_icon, src: dropdown_svg_1.default, alt: "..." })));
                    } }),
                react_1.default.createElement(Dropdown_1.default, { onChange: languageChangeHandler, itemKey: "code", itemValue: "short", list: languageList, selected: currentLanguage, itemTemplate: function (elem) {
                        return (react_1.default.createElement(react_1.Fragment, null,
                            react_1.default.createElement("span", { className: "flag " + elem.flag }),
                            react_1.default.createElement("span", null, elem.short),
                            react_1.default.createElement("img", { className: styles_module_scss_1.default.dropdown_icon, src: dropdown_svg_1.default, alt: "..." })));
                    } })),
            !hidePostButton && (react_1.default.createElement("div", { className: "new-post-button" }, !isAnnouncementPage && (react_1.default.createElement("a", { onClick: openAnnouncement }, t('HEADER.Button'))))))))));
});
exports.default = TopHeader;
